<nb-badge [status]="status" [text]="text" [class]="size"> </nb-badge>
